import { render, staticRenderFns } from "./ReportCriteriaForm.vue?vue&type=template&id=520da3de&scoped=true&"
import script from "./ReportCriteriaForm.vue?vue&type=script&lang=js&"
export * from "./ReportCriteriaForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportCriteriaForm.vue?vue&type=style&index=0&id=520da3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520da3de",
  null
  
)

export default component.exports